<script lang="ts">
	import { Field, Control, Label, FieldErrors } from 'formsnap';
	import PasswordInput from '@lib/components/global/auth/PasswordInput.svelte';
	import { changePasswordSchema } from '@lib/schemas/auth.schema';
	import { superForm } from 'sveltekit-superforms';
	import { zod } from 'sveltekit-superforms/adapters';
	import { getFlash } from 'sveltekit-flash-message';
	import { page } from '$app/stores';
	import CenterNotify from '../global/micro/CenterNotify.svelte';
	import type { SuperValidated, Infer } from 'sveltekit-superforms';

	export let isShowPanel = false,
		modalEl: HTMLDialogElement;

	const formInstance = $page.data.formChangePassword as SuperValidated<
		Infer<typeof changePasswordSchema>
	>;

	const form = superForm(formInstance, {
		validationMethod: 'auto',
		validators: zod(changePasswordSchema),
		resetForm: false,
		onUpdate({ result }) {
			if (result.type === 'success') {
				setTimeout(() => {
					isShowPanel = false;
					modalEl.close();
				}, 1000);
			}
		}
	});

	const { form: formData, enhance, delayed } = form;
	const flash = getFlash(page);

	$: if ($flash) setTimeout(() => ($flash = undefined), 3000);
</script>

{#if $flash}
	<CenterNotify isShow={!!$flash} message={$flash.message} type={$flash.type} />
{/if}

<div class="change-password-panel">
	<h1 class="mb-4 text-lg font-semibold">Ganti Password</h1>
	<form method="POST" action="/actions/change-password" use:enhance>
		<div class="grid gap-4">
			<div class="field-group">
				<Field {form} name="old_password">
					<Control let:attrs>
						<Label>Password Lama</Label>
						<PasswordInput
							class="mt-2"
							placeholder="Masukkan Password Lama"
							bind:value={$formData.old_password}
							{attrs}
						/>
						{#if attrs['aria-invalid']}
							<FieldErrors class="error-text" />
						{/if}
					</Control>
				</Field>
			</div>
			<div class="field-group">
				<Field {form} name="password">
					<Control let:attrs>
						<Label>Password Baru</Label>
						<PasswordInput
							class="mt-2"
							placeholder="Masukkan Password Baru"
							bind:value={$formData.password}
							{attrs}
						/>
						{#if attrs['aria-invalid']}
							<FieldErrors class="error-text" />
						{/if}
					</Control>
				</Field>
			</div>
			<div class="field-group">
				<Field {form} name="password_confirmation">
					<Control let:attrs>
						<Label>Konfirmasi Password Baru</Label>
						<PasswordInput
							class="mt-2"
							placeholder="Masukkan Konfirmasi Password Baru"
							bind:value={$formData.password_confirmation}
							{attrs}
						/>
						{#if attrs['aria-invalid']}
							<FieldErrors class="error-text" />
						{/if}
					</Control>
				</Field>
			</div>
		</div>
		<button type="submit" class="btn btn-primary btn-block mt-5" disabled={$delayed}>
			{#if $delayed}
				Menerapkan...
			{:else}
				Terapkan
			{/if}
		</button>
	</form>
</div>
